import advCore from "../../../tv24/js/es6/adv/advCore";

export default function (opt, newsId) {
    let dfpWrapper = document.getElementById('desktopBrandingDFP');
    let brandingWrapper = document.createElement('div');
    brandingWrapper.id = 'desktopBranding' + newsId;

    if(document.getElementById(brandingWrapper.id) != null){
        return;
    } else if(dfpWrapper !== null) {
        dfpWrapper.appendChild(brandingWrapper);
    } else {
        return;
    }

    advCore.defineDfpSlot({
        'name': opt.desktopBrandingSlotId,
        'sizes': [1, 1],
        'id': 'desktopBranding' + newsId,
        'targeting': opt.dfpTargeting,
        'callback': function (e) {
            if (e.isEmpty && window.innerWidth >= 1360) {
                // advCore.defineDfpSlot({
                //     'name': '/56301415/24tv_160x600_sticky_left',
                //     'sizes': [[160, 600], [120, 600]],
                //     'id': 'div-gpt-ad-1478690913385-0',
                //     'targeting': opt.dfpTargeting,
                //     'callback': function (e) {
                //         document.getElementById('sticky_left').style.display = 'block'
                //     }
                // });
                // advCore.defineDfpSlot({
                //     'name': '/56301415/24tv_160x600_sticky_rigth',
                //     'sizes': [[160, 600], [120, 600]],
                //     'id': 'div-gpt-ad-1478690913385-1',
                //     'targeting': opt.dfpTargeting,
                //     'callback': function (e) {
                //         document.getElementById('sticky_right').style.display = 'block'
                //     }
                // });
                //
                // googletag.cmd.push(function () {
                //     googletag.display('div-gpt-ad-1478690913385-0');
                // });
                // googletag.cmd.push(function () {
                //     googletag.display('div-gpt-ad-1478690913385-1');
                // });
            }
        }
    });

    googletag.cmd.push(function () {
        googletag.display('desktopBranding' + newsId);
    });
}